<ng-container *transloco="let t">
  <section
    class="category-picker-component"
    [class.widescreen]="(biggerThan$ | async)?.mobileL"
    [class.hugescreen]="(biggerThan$ | async)?.sm">
    <h3>{{ t('label_popular_categories') }}</h3>
    <span class="item fixed-space-16" aria-hidden="true"></span>
    <app-popsy-scroller [display]="!forceRow ? 'category-picker' : null">
      @for (product of categorySignal(); track trackByModel) {
        <app-category-item class="item" [product]="product"></app-category-item>
      }
    </app-popsy-scroller>
  </section>
</ng-container>
